import { lazy, useEffect } from 'react';
import {
  URL_PROFILE,
  URL_FORGOT_PASSWORD,
  URL_STRATEGY_PAYMENT,
  URL_STRATEGY_DETAILS,
  URL_HOST_PORTFOLIO,
  URL_PORTFOLIO,
  URL_COPY_TRADING_PAYMENT,
  URL_CREATE_BOT,
  URL_BOTS,
  URL_DEPLOY_STRATEGY,
  URL_NO_CODE_BUILDER,
  URL_PORTFOLIO_DETAILS,
  URL_LOGIN,
  URL_HOST_BOT,
} from 'Helpers/urls';
import { Switch, Route, useLocation, useHistory, Redirect } from 'react-router-dom';
import { useAuth } from 'Hooks/use-auth';

// Components
const Profile = lazy(() => import('../Components/Profile'));
const Payment = lazy(() => import('../Components/Payment'));
const CopyTradingPayment = lazy(() => import('../Components/Payment/CopyTrading'));
const NotFound = lazy(() => import('../Components/Pages/not-found'));
const StrategyDetails = lazy(() => import('../Components/StrategyDetails'));
const HostPortfolio = lazy(() => import('../Components/HostPortfolio'));
const Portfolio = lazy(() => import('../Components/Portfolio'));
const CreateBot = lazy(() => import('../Components/CreateBot'));
const Bots = lazy(() => import('../Components/Bots'));
const DeployStrategy = lazy(() => import('../Components/DeployStrategy'));
const NoCodeBuilder = lazy(() => import('../Components/NoCodeBuilder'));
const PortfolioDetails = lazy(() => import('../Components/PortfolioDetails'));
const HostBot = lazy(() => import('../Components/HostBot'));

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const user = useAuth();
  const { pathname } = useLocation();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (user.isLoggedIn) return <Component {...props} />;
        return (
          <Redirect
            to={{
              pathname: URL_LOGIN,
              state: { from: pathname },
            }}
          />
        );
      }}
    />
  );
};

export default () => {
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (pathname.includes('/registration') || pathname === URL_FORGOT_PASSWORD) {
      history.push(URL_PROFILE);
    }
  }, [pathname, history]);

  return (
    <Switch>
      <ProtectedRoute path={URL_PROFILE} exact component={Profile} />
      <ProtectedRoute path={URL_HOST_PORTFOLIO} exact component={HostPortfolio} />
      <ProtectedRoute path={URL_STRATEGY_PAYMENT} exact component={Payment} />
      <ProtectedRoute path={URL_COPY_TRADING_PAYMENT} exact component={CopyTradingPayment} />
      <ProtectedRoute path={URL_STRATEGY_DETAILS} exact component={StrategyDetails} />
      <ProtectedRoute path={URL_PORTFOLIO} exact component={Portfolio} />
      <ProtectedRoute path={URL_BOTS} exact component={Bots} />
      <ProtectedRoute path={URL_CREATE_BOT} exact component={CreateBot} />
      <ProtectedRoute path={URL_DEPLOY_STRATEGY} exact component={DeployStrategy} />
      <ProtectedRoute path={URL_NO_CODE_BUILDER} component={NoCodeBuilder} />
      <ProtectedRoute path={URL_PORTFOLIO_DETAILS} exact component={PortfolioDetails} />
      <ProtectedRoute path={URL_HOST_BOT} exact component={HostBot} />
      <NotFound default />
    </Switch>
  );
};
